import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Typography } from '@material-ui/core';

import { useCreateLoginTokenForCurrentUserInClientMutation } from 'api';
import { useNotify, useProtectedClient } from 'hooks';
import { getRootDomain } from 'utilities';

const DeveloperLogin: FC = () => {
  const notify = useNotify();
  const client = useProtectedClient();

  const { mutateAsync } = useCreateLoginTokenForCurrentUserInClientMutation({
    onError: notify.mutationError,
  });

  async function handleLogin() {
    const url = `https://${getRootDomain()}/integrations/readme`;
    const newWindow = window.open(url, 'Developer Login');
    const data = await mutateAsync({ client_id: client.id });
    const { createLoginTokenForCurrentUserInClient } = data;

    newWindow.location.href = `${url}?token=${createLoginTokenForCurrentUserInClient}`;
    newWindow.focus();
  }

  return (
    <Typography>
      <Trans key="components:developerLogin">
        For testing API calls, we recommend{' '}
        <Typography
          style={{ cursor: 'pointer' }}
          component="span"
          color="primary"
          onClick={handleLogin}
        >
          logging into
        </Typography>{' '}
        our developer documentation.
      </Trans>
    </Typography>
  );
};

export default DeveloperLogin;
